import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  Autocomplete,
} from "@mui/material";
import { UseRelatedProduct } from "./UseRelatedProduct";
import SearchComProduct from "./SearchComProduct";
import { useSnackbar } from "notistack";
import ClearIcon from "@mui/icons-material/Clear";
import CircleIcon from "@mui/icons-material/Circle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function ProductRelatedDelete(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { getProductTypes, deleteRelatedProducts, getFilterCount } =
    UseRelatedProduct();
  const [filterCount, setFilterCount] = useState();
  const [giftName, setGiftName] = useState("");
  const [state, setState] = useState({
    relatedID: undefined,
    newGiftId: undefined,
  });
  const [openRelated, setOpenRelated] = useState(false);
  const [productTypes, setProductTypes] = useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (openRelated) {
      getProductTypes((callback) => {
        setProductTypes(callback);
      });
      let newBody = Object.fromEntries(
        Object.entries(state).filter(([_, v]) => v != undefined)
      );
      getFilterCount(newBody, (callback) => {
        setFilterCount(callback);
      });
    }
  }, [openRelated]);

  return (
    <Box>
      <Dialog
        open={openRelated}
        maxWidth="sm"
        sx={{
          "& .MuiPaper-root ": {
            height: "25%",
          },
        }}
        fullWidth
        onClose={() => {
          setState({
            ...state,
            type: undefined,
          });
          setOpenRelated(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography color="secondary" variant="subtitle2">
              {filterCount} مورد یافت شد
            </Typography>
            <IconButton
              onClick={() => {
                setState({
                  ...state,
                  type: undefined,
                });
                setOpenRelated(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box sx={{ width: isSmall ? "100%" : "80%" }}>
              <Autocomplete
                size="small"
                // value={state.headerColorName ? state.headerColorName : ""}
                onChange={(event, newValue) => {
                  setState({
                    ...state,
                    type: newValue,
                  });
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) => {
                  if (option) {
                    return productTypes.find((m) => m.id == option).type;
                  }
                  return "";
                }}
                options={productTypes ? productTypes.map((m) => m.id) : []}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="نوع" />
                )}
              />
            </Box>
            <Button
              onClick={() => {
                if (!state.type) {
                  enqueueSnackbar("لطفا نوع را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                }
                let model = {
                  relatedID: state.relatedID ? state.relatedID : undefined,
                  type: state.type ? state.type : undefined,
                };
                deleteRelatedProducts(model, () => {
                  setOpenRelated(false);
                  setState({
                    productID: undefined,
                    brandID: undefined,
                    groupID: undefined,
                    type: undefined,
                    minCost: undefined,
                    maxCost: undefined,
                    relatedID: undefined,
                    expireDate: undefined,
                  });
                  props.callback();
                });
              }}
              color="secondary"
              variant="contained"
            >
              حذف
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس محصول مرتبط
        </Typography>
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 9"}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <SearchComProduct
              changeRelated
              productID={state.relatedID}
              productModel={state}
              setProductModel={setState}
            />
            <Button
              disabled={!state.relatedID ? true : false}
              sx={{ mr: 2, width: "70px" }}
              variant="contained"
              onClick={() => {
                setOpenRelated(true);
              }}
            >
              عملیات
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
